// Vue 2 Options API equivalent of the live input preview in ai_elearning.
export default {
  data () {
    return { speechStatus: { busy: false, message: '', error: false, transcript: '', assessment: null } }
  },
  computed: {
    speechInputText: {
      get () { return this.speechStatus.busy ? this.appendSpeechText(this.speechStatus.transcript) : this.selfText },
      set (value) { if (!this.speechStatus.busy) this.selfText = value }
    }
  },
  watch: {
    speechInputText () {
      this.$nextTick(() => {
        const input = this.$refs.input3
        if (this.speechStatus.busy && input) input.scrollLeft = input.scrollWidth
      })
    }
  },
  methods: {
    appendSpeechText (spoken) {
      return this.selfText + (spoken || '')
    },
    cancelSpeechRecording () {
      if (this.$refs.speechRecognition) this.$refs.speechRecognition.cancelRecording()
    }
  }
}
